import { ColorSchemes } from 'types/Result';
import { at } from 'utils/at';

export const getFirstScheme = (colorSchemes: ColorSchemes) => {
  return at(colorSchemes, 0);
};
